import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapBdc.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Mirror_SAP_BDC_Inbound_header),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Mirror_SAP_BDC_Inbound_header)
    ]
})
export class SapBdcLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
